import type { FoldableItem } from './global.type'

export const enum ProviderName {
  linxo = 'Oxlin',
  lcl = 'internal',
  selfCare = 'Self-Care',
}

export const APP_ACTIONS = {
  cancel: 'cancel',
  confirm: 'confirm',
  delete: 'delete',
  edit: 'edit',
  save: 'save',
  back: 'back',
} as const

export type AppAction = ValueOf<typeof APP_ACTIONS>

export const LIFE_INSURANCE_CREATED_ID = 'created_av'

export const PLATFORMS = {
  rct: 'rct',
  homologation: 'homologation',
  release: 'release',
  dev: 'dev',
  unitTest: 'unitTest',
}

export type LabelValueType = {
  label: string
  value: string
}

export const MX_CLASSICAL_GAUGE_MAX_AGE = 65

export enum COMPARISON_METHOD {
  reverseOrder = 'reverseOrder',
  insensitive = 'insensitive',
}

export const DEFAULT_FOLDABLE_ITEM: FoldableItem = {
  isOpen: false,
}

// eslint-disable-next-line unicorn/empty-brace-spaces
export function voidFunction() {}

export const LOCAL_STORAGE_KEYS = {
  USER_ROLE: 'user_role',
  USER_NAME: 'username',
  TARGET_ORIGIN: 'targetOrigin',
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refresh_token',
} as const

export const SESSION_STORAGE_KEYS = {
  USER_PRECISIONS: 'user_precisions',
  ACCESS_TOKEN: 'accessToken',
}

export const CUSTOM_HEADERS = {
  MOCK_SCENARIO: 'x-mock-scenario',
  MOCK_PAGE_PATH: 'x-mock-page-path',
} as const
